export const Authenticated = (state) => state.auth.data

export const PlayMode = (state) => state.play.data

export const WalletBalanceUpdate = (state) => state.getWalletUpdate.data
